"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgFileVisualizationFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11 2v5.998c.014.303.034.52.062.65a6.742 6.742 0 00-1.224.712C9.68 9.12 9.4 9 9 9h-.999c-.667 0-1 .333-1.001 1 0 .667.333 1 1 1l.244-.001c-.998 1.446-1.47 3.321-1.1 5.374.337 1.868 1.642 3.884 3.74 4.876 1.027.486 2.007.732 3.008.751h-8.89c-1.274 0-1.94-.607-1.998-1.822L3 20V4c0-1.273.607-1.938 1.822-1.996L5 2h6zm7.383 19.602c-.293.238-.696.37-1.205.394L17 22h-3.108c.8.016 1.615-.114 2.48-.382.065-.02.736-.025 2.011-.016zM14 10a5 5 0 014.178 7.747l.095.096 2.483 2.492c.393.447.243 1.013-.087 1.342-.33.328-.896.469-1.316.054l-.044-.043-2.532-2.53A5 5 0 1114 10zm0 2a3 3 0 100 6 3 3 0 000-6zm-1-9.816c.252.125.531.342.84.651l.156.162 4.007 4.006c.425.379.698.71.817.994H13V2.185z' }))); };
exports.default = SvgFileVisualizationFilled;
//# sourceMappingURL=FileVisualizationFilled.js.map